<app-page-header
  [title]="'Solicitudes'"
  [subtitle]="'Módulo de gestión de solicitudes de vinculación'"
></app-page-header>

<div *ngIf="showApplicationTable">
  <app-solicitudes-table
    [applications]="applications"
    [preservedViewSelected]="tableState.viewSelected"
    [preservedFilters]="tableState.filters"
    (reviewApplication)="reviewApplication($event)"
    (reviewTransfer)="reviewTransfer($event)"
    (reviewRenewal)="reviewRenewal($event)"
    (editApplication)="editApplication($event)"
    (stateChange)="onTableStateChange($event)"
  ></app-solicitudes-table>
</div>

<div *ngIf="showApplicationReview">
  <app-solicitud-review
    [application]="applicationToReview"
    (goToBackEvent)="quitOfRewiew($event)"
  ></app-solicitud-review>
</div>

<div *ngIf="showTransferReviw">
  <app-transfer-review
    [transfer]="transferToReview"
    (goToBackEvent)="quitOfRewiew($event)"
  >
  </app-transfer-review>
</div>

<div *ngIf="showRenewalReview">
  <app-renewal-review
    [renewal]="renewalToReview"
    (goToBackEvent)="quitOfRewiew($event)"
  >
  </app-renewal-review>
</div>

<div *ngIf="showApplicationForm">
  <app-solicitud-form
    [application]="applicationToEdit"
    (goToBackEvent)="quitOfForm($event)"
  ></app-solicitud-form>
</div>
